import { render, staticRenderFns } from "./VisibleBindDialog.vue?vue&type=template&id=27cf8470&scoped=true"
import script from "./VisibleBindDialog.vue?vue&type=script&lang=js"
export * from "./VisibleBindDialog.vue?vue&type=script&lang=js"
import style0 from "./VisibleBindDialog.vue?vue&type=style&index=0&id=27cf8470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf8470",
  null
  
)

export default component.exports